webpackJsonp([188595303951472],{

/***/ 319:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(19);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	__webpack_require__(319);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PortfolioList = function PortfolioList(_ref) {
	  var title = _ref.title,
	      items = _ref.items;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'portfolio-title' },
	      title
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'portfolio-list' },
	      items.map(function (item, i) {
	        return i !== items.length - 1 ? _react2.default.createElement(_gatsbyImage2.default, {
	          className: 'portfolio-item',
	          sizes: item.sizes,
	          key: item.id
	        }) : _react2.default.createElement(_gatsbyImage2.default, {
	          className: 'portfolio-item-last',
	          sizes: item.sizes,
	          key: item.id
	        });
	      })
	    )
	  );
	};
	
	exports.default = PortfolioList;
	module.exports = exports['default'];

/***/ }),

/***/ 230:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PortfolioList = __webpack_require__(222);
	
	var _PortfolioList2 = _interopRequireDefault(_PortfolioList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PhotoPage = function PhotoPage(_ref) {
	  var data = _ref.data;
	
	  var items = data.allFile.edges.map(function (pic) {
	    return {
	      sizes: pic.node.childImageSharp.sizes,
	      id: pic.node.id
	    };
	  });
	
	  return _react2.default.createElement(_PortfolioList2.default, { items: items, title: 'photography' });
	};
	
	exports.default = PhotoPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-photography-index-js-23ff0736c6dfa8cddb0d.js